// This file is now merged into MfaSteps.tsx. Please use MfaSteps.tsx for the main step box and step logic.
import React from "react";
import Step1Start from "./steps/Step1Start";
import Step2Qr from "./steps/Step2Qr";
import Step3Code from "./steps/Step3Code";
import { StyleSheet, View } from "react-native";

type MfaStepProps = {
  onStart: () => void;
  onCancel: () => void;
  onPrevStep: () => void;
  onVerify: () => void;
  onCodeChange: (code: string) => void;
  code: string;
  qrUri: string;
  loading: boolean;
  error: string;
  verified: boolean;
  step: number;
  children?: React.ReactNode;
};

export default function MfaSteps(props: MfaStepProps) {
  const { step, children, ...otherProps } = props;

  return (
    <View style={styles.container}>
      {step === 1 && <Step1Start {...otherProps} />}
      {step === 2 && <Step2Qr {...otherProps} />}
      {step === 3 && <Step3Code {...otherProps} />}
      {children}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    borderRadius: 12,
    padding: 20,
    margin: 10,
    display: "flex",
    border: "1px solid lightgray",
    flexDirection: "column",
    alignItems: "center",
  },
});
